import { node, string, shape } from 'prop-types';
import React from 'react';
import Link from 'components/Link';

function LogoLink({ className, href, gtmAttrs, logo, placement }) {
  return (
    <Link href={href}>
      <a
        className={className}
        {...gtmAttrs}
        aria-label={`${placement} logo link`}
      >
        {logo}
      </a>
    </Link>
  );
}

LogoLink.propTypes = {
  className: string,
  href: string.isRequired,
  gtmAttrs: shape({
    // data-gtm-*
  }),
  logo: node.isRequired,
  placement: string
};

LogoLink.defaultProps = {
  className: undefined,
  gtmAttrs: {},
  placement: undefined
};

export default LogoLink;
